<template>
  <div class="voting">
    <b-button pill size="sm" :variant="upvoted ? 'success' : 'outline-success'" @click="upvote"><i class="fa fa-thumbs-up"></i> {{upvotes}}</b-button>&nbsp;
    <b-button pill size="sm" :variant="downvoted ? 'danger' : 'outline-danger'" @click="downvote"><i class="fa fa-thumbs-down"></i> {{downvotes}}</b-button>
  </div>
</template>

<script>

export default {
  name: 'Votes',

  props: ['suggestion'],
  computed: {
    upvoted: function () {
      return this.suggestion.score === '1'
    },
    downvoted: function () {
      return this.suggestion.score === '-1'
    },
    upvotes: function () {
      return this.suggestion.upvotes == null ? 0 : this.suggestion.upvotes
    },
    downvotes: function () {
      return this.suggestion.downvotes == null ? 0 : this.suggestion.downvotes
    }
  },
  methods: {
    vote (score) {
      this.$http.post(process.env.VUE_APP_URL + '/votes/' + this.suggestion.sug_id, {
        score: score,
        token: this.$cookies.get('token')
      })
        .then(response => {
          let result = response.data
          this.suggestion.upvotes = result.upvotes
          this.suggestion.downvotes = result.downvotes
          this.suggestion.score = result.score
        })
    },
    upvote () {
      this.vote(1)
    },
    downvote () {
      this.vote(-1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .voting {
    padding: 1em 0px;
  }
  button {
    width: 4em;
  }
</style>
